import { Link, TableColumn } from 'ui/components'

export const columns: TableColumn<{ id: number; name: string }>[] = [
  {
    title: 'Relationship link',
    key: 'name',
    align: 'left',
    color: '#868686',
    width: '292px',
    render: (item) => (
      <Link to="/relationships/$id" params={{ id: item.id.toString() }}>
        {item.name}
      </Link>
    )
  }
]
